import { Theme } from '@mui/material';
import { ThemeMode } from '~/types/config';

export default function Paper(theme: Theme) {
  return {
    MuiPaper: {
      styleOverrides: {
        root: {
          // Remove white overlay in dark mode.
          backgroundImage: theme.palette.mode === ThemeMode.DARK ? 'none' : undefined,
        },
      },
    },
  };
}
